import { render, staticRenderFns } from "./refundQueueDetails.vue?vue&type=template&id=b903343a&scoped=true"
import script from "./refundQueueDetails.vue?vue&type=script&lang=js"
export * from "./refundQueueDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b903343a",
  null
  
)

export default component.exports